'use strict';

const { String, Boolean } = require('../lib/types');
const { make } = require('../lib/build-spec');

module.exports = {
    generalAlert: make(Boolean, 'generalAlert', 'Alert'),
    generalPleasant: make(Boolean, 'generalPleasant', 'Pleasant'),
    generalTalkative: make(Boolean, 'generalTalkative', 'Talkative'),
    generalNAD: make(Boolean, 'generalNAD', 'NAD'),
    generalPerson: make(Boolean, 'generalPerson', 'Person'),
    generalPlace: make(Boolean, 'generalPlace', 'Place'),
    generalTime: make(Boolean, 'generalTime', 'Time'),
    generalSituation: make(Boolean, 'generalSituation', 'Situation'),
    generalOther: make(Boolean, 'generalOther', 'Other'),
    generalOtherText: make(String, 'generalOtherText', 'Other Text'),

    headNormocephalkANDtemporalWasting: make(
        String,
        'headNormocephalkANDtemporalWasting',
        'Normocephalic'
    ),
    headAtraumaticANDstructuralAnomaly: make(
        String,
        'headAtraumaticANDstructuralAnomaly',
        'Atraumatic'
    ),
    headOther: make(Boolean, 'headOther', 'Other'),
    headOtherText: make(String, 'headOtherText', 'Other Text'),

    abdomenSoftOrFirm: make(String, 'abdomenSoftOrFirm', 'Firmness'),
    abdomenTender: make(String, 'abdomenTender', 'Tenderness'),
    abdomenDistended: make(String, 'abdomenDistended', 'Disdended'),
    abdomenNoOrganomegalyANDorganomegaly: make(
        String,
        'abdomenNoOrganomegalyANDorganomegaly',
        'Organomegaly'
    ),
    abdomenActiveBS: make(String, 'abdomenActiveBS', 'Active BS'),
    abdomenSuprapubicTenderness: make(
        String,
        'abdomenSuprapubicTenderness',
        'Suprapubic Tenderness'
    ),
    abdomenOther: make(Boolean, 'abdomenOther', 'Other'),
    abdomenOtherText: make(String, 'abdomenOtherText', 'Other Text'),

    backTender: make(String, 'backTender', 'Tenderness'),
    backMasses: make(String, 'backMasses', 'Masses'),
    backCVA: make(String, 'backCVA', 'CVA'),
    backROM: make(String, 'backROM', 'ROM'),
    backAlignment: make(String, 'backAlignment', 'Alignment'),
    backOther: make(Boolean, 'backOther', 'Other'),
    backOtherText: make(String, 'backOtherText', 'Other Text'),

    cardiovascularRhythm: make(String, 'cardiovascularRhythm', 'Rhythm'),
    cardiovascularRate: make(String, 'cardiovascularRate', 'Rate'),
    cardiovascularNormalSoundANDabnormalSound: make(
        String,
        'cardiovascularNormalSoundANDabnormalSound',
        'Heart Valve Sounds'
    ),
    cardiovascularMurmur: make(String, 'cardiovascularMurmur', 'Murmur'),
    cardiovascularOther: make(Boolean, 'cardiovascularOther', 'Other'),
    cardiovascularOtherText: make(
        String,
        'cardiovascularOtherText',
        'Other Text'
    ),

    eyesIcterus: make(String, 'eyesIcterus', 'Icterus'),
    eyesPerrlbANDanisocoria: make(
        String,
        'eyesPerrlbANDanisocoria',
        'PERRLB and Anisocaria'
    ),
    eyesEomiANDnystagmus: make(
        String,
        'eyesEomiANDnystagmus',
        'EOMI and Nystagmus'
    ),
    eyesOther: make(Boolean, 'eyesOther', 'Other'),
    eyesOtherText: make(String, 'eyesOtherText', 'Other Text'),

    extremitiesClubbing: make(String, 'extremitiesClubbing', 'Clubbing'),
    extremitiesTender: make(String, 'extremitiesTender', 'Tender'),
    extremitiesROM: make(String, 'extremitiesROM', 'ROM'),
    extremitiesEdema: make(String, 'extremitiesEdema', 'Edema'),
    extremitiesCyanosis: make(String, 'extremitiesCyanosis', 'Cyanosis'),
    extremitiesOther: make(Boolean, 'extremitiesOther', 'Other'),
    extremitiesOtherText: make(String, 'extremitiesOtherText', 'Other Text'),

    genitourinaryDeferred: make(Boolean, 'genitourinaryDeferred', 'Deferred'),
    genitourinaryOther: make(Boolean, 'genitourinaryOther', 'Other'),
    genitourinaryOtherText: make(
        String,
        'genitourinaryOtherText',
        'Other Text'
    ),

    integumentaryRashes: make(String, 'integumentaryRashes', 'Rashes'),
    integumentaryLesions: make(String, 'integumentaryLesions', 'Lesions'),
    integumentaryJaundice: make(String, 'integumentaryJaundice', 'Jaundice'),
    integumentaryOther: make(Boolean, 'integumentaryOther', 'Other'),
    integumentaryOtherText: make(
        String,
        'integumentaryOtherText',
        'Other Text'
    ),

    neckLAD: make(String, 'neckLAD', 'LAD'),
    neckROM: make(String, 'neckROM', 'ROM'),
    neckOther: make(Boolean, 'neckOther', 'Other'),
    neckOtherText: make(String, 'neckOtherText', 'Other Text'),

    neurologicalMotor: make(String, 'neurologicalMotor', 'Motor'),
    neurologicalSensory: make(String, 'neurologicalSensory', 'Sensory'),
    neurologicalGait: make(String, 'neurologicalGait', 'Gait'),
    neurologicalCranialNerves: make(
        String,
        'neurologicalCranialNerves',
        'Cranial Nerves'
    ),
    neurologicalOther: make(Boolean, 'neurologicalOther', 'Other'),
    neurologicalOtherText: make(String, 'neurologicalOtherText', 'Other Text'),

    mentalhealthAlertness: make(String, 'mentalhealthAlertness', 'Alertness'),
    mentalhealthOrientation: make(
        String,
        'mentalhealthOrientation',
        'Orientation'
    ),
    mentalhealthAffect: make(String, 'mentalhealthAffect', 'Affect'),
    mentalhealthOther: make(Boolean, 'mentalhealthOther', 'Other'),
    mentalhealthOtherText: make(String, 'mentalhealthOtherText', 'Other Text'),

    respiratoryWheezing: make(String, 'respiratoryWheezing', 'Wheezing'),
    respiratoryCrackles: make(String, 'respiratoryCrackles', 'Crackles'),
    respiratoryMovement: make(String, 'respiratoryMovement', 'Movement'),
    respiratoryOther: make(Boolean, 'respiratoryOther', 'Other'),
    respiratoryOtherText: make(String, 'respiratoryOtherText', 'Other Text')
};
